// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";

import accordion from "@awc/XDL/PreStyle/accordion";
import breadcrumbs from "@awc/XDL/PreStyle/breadcrumbs";
import breakpoints from "@awc/XDL/PreStyle/breakpoints";
import button from "@awc/XDL/PreStyle/button";
import checkbox from "@awc/XDL/PreStyle/checkbox";
import clickable from "@awc/XDL/PreStyle/clickable";
import colors from "@awc/XDL/PreStyle/colors";
import dataTable from "@awc/XDL/PreStyle/dataTable";
import datePicker from "@awc/XDL/PreStyle/datePicker";
import dynamicDropdown from "@awc/XDL/PreStyle/dynamicDropdown";
import focus from "@awc/XDL/PreStyle/focus";
import footer from "@awc/XDL/PreStyle/footer";
import formField from "@awc/XDL/PreStyle/formField";
import globalStyle from "@awc/XDL/PreStyle/globalStyle";
import header from "@awc/XDL/PreStyle/header";
import icon from "@awc/XDL/PreStyle/icon";
import link from "@awc/XDL/PreStyle/link";
import lists from "@awc/XDL/PreStyle/lists";
import loadingSpinner from "@awc/XDL/PreStyle/loadingSpinner";
import menu from "@awc/XDL/PreStyle/menu";
import modal from "@awc/XDL/PreStyle/modal";
import overflowMenu from "@awc/XDL/PreStyle/overflowMenu";
import pagination from "@awc/XDL/PreStyle/pagination";
import panelMenu from "@awc/XDL/PreStyle/panelMenu";
import radio from "@awc/XDL/PreStyle/radio";
import select from "@awc/XDL/PreStyle/select";
import shadows from "@awc/XDL/PreStyle/shadows";
import tab from "@awc/XDL/PreStyle/tab";
import tag from "@awc/XDL/PreStyle/tag";
import textArea from "@awc/XDL/PreStyle/textArea";
import toast from "@awc/XDL/PreStyle/toast";
import tooltip from "@awc/XDL/PreStyle/tooltip";
import typography from "@awc/XDL/PreStyle/typography";
import zIndex from "@awc/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    clickable,
    dataTable,
    datePicker,
    // drawer,
    dynamicDropdown,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    // loadingOverlay,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // tagsField,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
    footer,
} as unknown as xBaseTheme;
